export const backupsActions = {
    GET_BACKUPS: 'GET_BACKUPS',
    SET_BACKUPS: 'SET_BACKUPS',
    DELETE_BACKUP: 'DELETE_BACKUP',
    RESTORE_ENVIRONMENTS:'RESTORE_ENVIRONMENTS',
    BACKUP_ENVIRONMENT: 'BACKUP_ENVIRONMENT',
    SET_BACKUP_ENVIRONMENT: 'SET_BACKUP_ENVIRONMENT',
    GET_BACKUPS_ACTIONS: 'GET_BACKUPS_ACTIONS',
    SET_BACKUPS_ACTIONS: 'SET_BACKUPS_ACTIONS',
    GET_RESTORE_ACTIONS: 'GET_RESTORE_ACTIONS',
    SET_RESTORE_ACTIONS: 'SET_RESTORE_ACTIONS',
    GET_BACKUPS_FOR_RESTORE: 'GET_BACKUPS_FOR_RESTORE',
    SET_BACKUPS_FOR_RESTORE: 'SET_BACKUPS_FOR_RESTORE',
    GET_STORAGE_TYPES: 'GET_STORAGE_TYPES',
    SET_STORAGE_TYPES: 'SET_STORAGE_TYPES'
};

const initState = {
    environmentId: null,
    //this way it will be inside an array
    backups: [],
    backActions: [],
    restoreActions: [],
    backupForRestore: [],
    storageTypes: []
};

export const backupsReducer = (state = initState, action: any) => {
    switch (action.type) {
        case backupsActions.SET_BACKUPS:
            return Object.assign({}, state, action.payload);

        case backupsActions.SET_BACKUP_ENVIRONMENT:
                return Object.assign({}, state, action.payload);            

        case backupsActions.SET_BACKUPS_ACTIONS:
            return Object.assign({}, state, action.payload);

        case backupsActions.SET_RESTORE_ACTIONS:
            return Object.assign({}, state, action.payload);
        
        case backupsActions.SET_BACKUPS_FOR_RESTORE:
            return Object.assign({}, state, action.payload);
        
        case backupsActions.SET_STORAGE_TYPES:
            return Object.assign({}, state, action.payload);
    

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/backupsReducer.ts